export default __webpack_public_path__ + "static/media/trikot_base.11658747.png";